import { isWeb } from '@gluestack-ui/nativewind-utils/IsWeb';

import { STORAGE_KEYS } from '@/constants/storageKeys';
import { safeLocalStorageGetItem } from '@/util/platformStorage';

let nativeAnalyticsDisabled = false;

export function setNativeAnalyticsDisabled(disabled: boolean): void {
  nativeAnalyticsDisabled = disabled;
}

export function isAnalyticsDisabledSync(): boolean {
  if (isWeb) {
    const value = safeLocalStorageGetItem(STORAGE_KEYS.ANALYTICS_SEGMENT_ENABLED);

    return value === 'false';
  }

  return nativeAnalyticsDisabled;
}
